import { ParentCampaignObject } from "../types/APITypes";
import { usePost } from "./requestAPI/apiPost";


type SetActivity = {
    result: string;
}

type UseSetExistingParentActivityResponse = [
    (data: ParentCampaignObject) => Promise<SetActivity | null>,
    {
        value?: SetActivity;
        loading: boolean;
        called: boolean;
        error?: string;
        isSuccess: boolean;
    }
]

export const useSetExistingParentActivity = (): UseSetExistingParentActivityResponse => {
    
    const [post, postState] = usePost<SetActivity, ParentCampaignObject>({
        url: `parent-campaigns/set-inactive`
    })

    const setActivity = async (
        data : ParentCampaignObject
    ) : Promise<SetActivity | null> => {

        const result = await post(data);
        return result;
    }

    return [setActivity, postState];
};